// Translated Component
// src/components/TranslatedComponent.js
import React from 'react';
import { FormattedMessage } from 'react-intl';

const TranslatedComponent = () => {
    return (
        <div>
            <h1></h1>
        </div>
    );
};

export default TranslatedComponent;